// 路由入口

import Vue from 'vue'
import Router from 'vue-router'

import router from './router'
import './hooks'

Vue.use(Router)

export default router
